module.exports = __webpack_public_path__ + "media/images/themes/light/logo-animated-aa2517e621cbb9051c9495d546c5d9d3.gif";